/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BookingUserEnvironment = {
    Web: 'WEB',
    MobileIos: 'MOBILE_IOS',
    MobileAndroid: 'MOBILE_ANDROID',
    Mcp: 'MCP',
    Chatgpt: 'CHATGPT',
    Claude: 'CLAUDE',
    ClaudeCode: 'CLAUDE_CODE',
    Codex: 'CODEX',
    Cursor: 'CURSOR',
    Opencode: 'OPENCODE',
    N8N: 'N8N',
    Api: 'API',
    Other: 'OTHER'
} as const;
export type BookingUserEnvironment = typeof BookingUserEnvironment[keyof typeof BookingUserEnvironment];


export function instanceOfBookingUserEnvironment(value: any): boolean {
    for (const key in BookingUserEnvironment) {
        if (Object.prototype.hasOwnProperty.call(BookingUserEnvironment, key)) {
            if (BookingUserEnvironment[key as keyof typeof BookingUserEnvironment] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingUserEnvironmentFromJSON(json: any): BookingUserEnvironment {
    return BookingUserEnvironmentFromJSONTyped(json, false);
}

export function BookingUserEnvironmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingUserEnvironment {
    return json as BookingUserEnvironment;
}

export function BookingUserEnvironmentToJSON(value?: BookingUserEnvironment | null): any {
    return value as any;
}

export function BookingUserEnvironmentToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingUserEnvironment {
    return value as BookingUserEnvironment;
}

